export const FormIdentifiers = Object.freeze({
  Dashboard: 'Dashboard',
  HomeScreen: 'HomeScreen',
  Project: 'Project',
  ProjectIssue: 'ProjectIssue',
  ProjectReceipt: 'ProjectReceipt',
  ResourceOne: 'ResourceOne',
  SimpleTask: 'SimpleTask',
  SapShiftLeaderReport: 'SapShiftLeaderReport',
  SourceList: 'SourceList',
  VatCode: 'VatCode',
  Country: 'Country',
  Currency: 'Currency',
  Language: 'Language',
  SupplierComplaint: 'SupplierComplaint',
  MaterialPlan: 'MaterialPlan',
  ItemType: 'ItemType',
  ItemTypeProperty: 'ItemTypeProperty',
  ServiceIssue: 'ServiceIssue',
  ServiceReceipt: 'ServiceReceipt',
  QuickCustomStatusMobile: 'QuickCustomStatusMobile',
  DeliveryDraft: 'DeliveryDraft',
  ServiceMonitor: 'ServiceMonitor',
  ProductionMaterial: 'ProductionMaterial',
  InventoryConversion: 'InventoryConversion',
  InventoryTransfer: 'InventoryTransfer',
  InventoryTransferDoc: 'InventoryTransferDoc',
  PurchaseDelivery: 'PurchaseDelivery',
  SupportingDocumentType: 'SupportingDocumentType',
});
